module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-R-16.20e1b0da.png";